import { API } from "../../apiSlice";

export const verifyRecaptchaApiSlice = API.injectEndpoints({
  endpoints: (builder) => ({
    verifyRecaptcha: builder.mutation({
      query: (data) => {
        return {
          url: "users/captcha/verify",
          method: "POST",
          body: data,
        };
      },
    }),
  }),
});

export const { useVerifyRecaptchaMutation } = verifyRecaptchaApiSlice;
